import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    OnInit,
    ViewChild,
} from '@angular/core'
import { PdfGeneratorService } from '../../../services/pdf-generator.service'

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoModalComponent implements OnInit {
    @Input() title = ''
    @Input() exportable = false

    @ViewChild('pdf_element')
    pdf_element!: ElementRef<HTMLElement>

    exportIsLoading = false

    constructor(private pdfGeneratorService: PdfGeneratorService) {}

    ngOnInit(): void {}

    public async exportAsPDF() {
        this.exportIsLoading = true
        let htmlElement = this.pdf_element.nativeElement
        const fileName = this.title
        await this.pdfGeneratorService.generate(htmlElement, fileName).finally(() => {
            this.exportIsLoading = false
        })
    }
}
